<template>
  <div class="tree-item">
    <ELink
      class="tree-item__link"
      color="result"
      :href="url"
      aria-hidden="true"
    >
      <EThumbnail
        :src="thumbnail"
        :alt="title"
        fallback-background
        class="tree-item__thumbnail"
      />
      <div class="tree-item__title">
        {{ title }}
      </div>
    </ELink>
  </div>
</template>

<script>
import ELink from '~~/common/vue/components/link';
import EThumbnail from '~~/common/vue/components/thumbnail';

export default {
  name: 'ETreeItem',
  components: {
    ELink,
    EThumbnail,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    labels: {
      type: Array,
      default: () => [],
    },
    isNative: {
      type: Boolean,
      required: true,
    },
    thumbnail: {
      type: String,
      default: '',
    },
    isEndangered: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    url() {
      const query = {
        q: this.title,
      };
      return this.$router.resolve({ path: '/search', query }).href;
    },
  },
};
</script>

<style lang="scss" scoped>
$thumbnail-size: 95px;

.tree-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: $space-1s;
  text-align: center;
}

.tree-item__link {
  width: min-content;
}

.tree-item__text {
  min-width: 0;
  width: 100%;
}

.tree-item__thumbnail {
  border-radius: $border-radius-l;
  overflow: hidden;
  height: $thumbnail-size;
  width: $thumbnail-size;
}

.tree-item__thumbnail:hover {
  @include elevation(2);
}

.tree-item__title {
  padding: $space-1s;
}
</style>
